import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-success-page',
  templateUrl: './success-page.component.html',
  styleUrls: ['./success-page.component.scss']
})
export class SuccessPageComponent implements OnInit,OnDestroy  {

  timeLeft: number = 60;
  interval: any;
  status: string = '';
  mihpayid: string = '';
  bookingData: any;
  returnvalue: any;
  updateStatus: any;
  paymentMode: any;
  bookingDetailsOnline: any;
  loaderCheck: boolean = false
  constructor(private _apiService: ApiService, private messageService: MessageService, private router: Router, private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      this.mihpayid = params.param1;
      this.status = params.param2;
    });
  }


  ngOnInit(): void {
    // window.location.reload();
    this.startCountdown();
    this.bookingData = localStorage.getItem('bookingDetails');
    this.bookingDetailsOnline = localStorage.getItem('retrunBookingOnlineDetails');
    this.paymentMode = localStorage.getItem('typeofPaymentMode');
    this.returnvalue = localStorage.getItem('returnPrimaryValue');
    console.log("bookingDetailsOnline", this.bookingDetailsOnline);

    console.log("paymentMode", this.paymentMode);
   // if (this.paymentMode == 'online') {
      this.bookingDetailsOnline = JSON.parse(this.bookingDetailsOnline);
      let object = {
        IsApproved: false,
        customerBookingId: this.returnvalue,
        customerName: "Customer Name",
      }
      
    console.log("paymentMode", this.status);
      // if (this.status == "success") {
        this.loaderCheck = true;
      this.returnvalue = localStorage.setItem('paymentstatus', this.status);
        console.log("paymenthis.mihpayid;tMode", this.mihpayid);
        this._apiService.approvalAPI(object).then((res: any) => {
          console.log(res);
          this.bookingDetailsOnline.transactionalId = this.mihpayid;
          this.bookingDetailsOnline.status = this.status;
          localStorage.setItem('paymenttransactionalId', this.mihpayid);
          this._apiService.customerPayment(this.bookingDetailsOnline).then((resp: any) => {
            
            this.router.navigateByUrl('receipt/' + this.returnvalue);
            this.loaderCheck = false;
          })
        })
      // }
   // }
    // else {
    //   if (this.bookingData) {
    //     let bookingData = JSON.parse(this.bookingData);
    //     let data = JSON.parse(localStorage.getItem('uplineData'));
    //     if (data?.upLineId) {
    //       this._apiService.customerBooking(bookingData).then((res: any) => {
    //         console.log(res);
    //         if (res.success) {
    //           this.messageService.add({
    //             severity: 'success',
    //             summary: 'Success',
    //             detail: 'Customer Registered Successfully!',
    //           });

    //           let object = {
    //             status: 'Success',
    //             customerBookingId: res.returnValue
    //           }
    //           this._apiService.customerPayment(object).then((resp: any) => {
    //             if (resp.success) {
    //               this.router.navigateByUrl('receipt/' + res.returnValue);
    //             }
    //           })
    //         }
    //       })
    //     }
    //     else {
    //       this.messageService.add({
    //         severity: 'error',
    //         summary: 'Error',
    //         detail: 'Something Went Worng!',
    //       });
    //     }
    //   }
    // }


  }
  startCountdown() {
    this.interval = setInterval(() => {
      this.timeLeft--;

      if (this.timeLeft <= 0) {
        clearInterval(this.interval);
    // Change route here
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}
